"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useMediaQuery = (mediaQuery, initialValue) => {
    const [matches, setMatches] = (0, react_1.useState)(initialValue);
    (0, react_1.useEffect)(() => {
        const mediaQueryList = window.matchMedia(mediaQuery);
        const listener = (e) => setMatches(e.matches);
        listener(mediaQueryList);
        const addListener = (event, callback) => mediaQueryList.addEventListener
            ? mediaQueryList.addEventListener(event, callback)
            : mediaQueryList.addListener(callback);
        const removeListener = (event, callback) => mediaQueryList.removeEventListener
            ? mediaQueryList.removeEventListener(event, callback)
            : mediaQueryList.removeListener(callback);
        addListener('change', listener);
        return () => removeListener('change', listener);
    }, [mediaQuery]);
    return matches;
};
exports.default = useMediaQuery;
